package components.colourChip

import common.EColors
import common.ECssClasses
import core.enums.EImages
import core.extensions.toClassName
import core.extensions.toColor
import core.io.dto.ColourDTO
import csstype.AlignItems
import csstype.BoxShadow
import csstype.Color
import csstype.Display
import csstype.GridArea
import csstype.JustifyContent
import csstype.JustifyItems
import csstype.LineStyle
import csstype.NamedColor
import csstype.Overflow
import csstype.Position
import csstype.TextAlign
import csstype.Visibility
import csstype.integer
import csstype.pc
import csstype.px
import emotion.react.css
import kotlinx.browser.window
import react.FC
import react.PropsWithClassName
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 27.10.22
 * Author : mariorosshirt
 */

external interface ColourChipProps : PropsWithClassName {
    var mColourDTO: ColourDTO
    var mOnClick: () -> Unit
    var mOverrideFixedWith: Boolean?
}

val ColourChip = FC<ColourChipProps> { props ->

    val mFixed = props.mOverrideFixedWith ?: props.mColourDTO.mFixed

    div {
        css(ECssClasses.CURSOR_HOVER.toClassName()) {
            zIndex = integer(1)
            textAlign = TextAlign.center
            display = Display.grid
            alignItems = AlignItems.center
            justifyItems = JustifyItems.center
        }

        div {
            css() {
                backgroundColor = NamedColor.white
                borderRadius = 8.px
                height = 72.times(if (window.innerWidth < 370) 0.75 else 1.0).px
                width = 72.times(if (window.innerWidth < 370) 0.75 else 1.0).px
                boxShadow = ("0px 0px 16px ${NamedColor.black}").unsafeCast<BoxShadow>()
                gridArea = "1 / 1".unsafeCast<GridArea>()
                visibility = if (props.mColourDTO.mHighlight) Visibility.visible else Visibility.collapse
            }
        }
        div {
            css() {
                backgroundColor = NamedColor.white
                borderRadius = 8.px
                height = 64.times(if (window.innerWidth < 370) 0.75 else 1.0).px
                width = 64.times(if (window.innerWidth < 370) 0.75 else 1.0).px
                gridArea = "1 / 1".unsafeCast<GridArea>()
            }
        }

        div {
            css() {
                backgroundColor = Color(props.mColourDTO.mColourCode)
                height = 56.times(if (window.innerWidth < 370) 0.75 else 1.0).px
                width = 56.times(if (window.innerWidth < 370) 0.75 else 1.0).px
                marginInline = 0.px
                borderRadius = 4.px
                overflow = Overflow.visible
                gridArea = "1 / 1".unsafeCast<GridArea>()
                position = Position.relative
            }
            if (mFixed) {
                div {
                    css {
                        width = 20.px
                        height = 20.px
                        backgroundColor = EColors.GRAY.toColor()
                        position = Position.absolute
                        alignItems = AlignItems.center
                        display = Display.flex
                        justifyContent = JustifyContent.center
                        borderRadius = 50.pc
                        borderWidth = 3.px
                        borderColor = NamedColor.white
                        borderStyle = LineStyle.solid
                        right = (-4).px
                        top = (-4).px
                        zIndex = integer(2)
                    }
                    img {
                        css {
                            width = 10.px
                        }
                        src = EImages.FIXED_ICON.mRelativePath
                    }
                }
            }
            onClick = {
                props.mOnClick()
            }
        }
    }

}